import { z } from "zod";


export const profileSchema = z.object({
	id_number: z.string({ error: "Resident number is required" }).min(3, "ID Number must be at least 3 characters"),
	first_name: z.string({ error: "First name is required" }).min(2, "First name is required"),
	middle_name: z.string().optional(),
	surname: z.string({ error: "Surname is required" }).min(2, "Surname is required"),
	email: z.email("Invalid email address"),
	college_email: z.email("Invalid college email address"),
	resident_status: z.string({ error: "Resident status is required" }).min(1, "Resident status is required"),
	training_center: z.string({ error: "Training center is required" }).min(1, "Training center is required"),
	department: z.string({ error: "Department is required" }).min(1, "Department is required"),
});


// export const registrationSchema = z.object({
// faculty: z.string(),
// subspecialty: z.string(),
// academicYear: z.string(),
// });